<template>
  <b-card no-body>
    <b-card-header
      v-if="showStatusFilter"
      class="pb-50"
    >
      <h5>
        {{ $t('Filters') }}
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="3"
          sm="6"
          class="mb-md-0 mb-2"
        >
          <label>Tìm kiếm</label>
          <b-input-group>
            <b-form-input
              v-model="localSearchQuery"
              class="d-inline-block"
              placeholder="tên,email,số điện thoại"
              @keyup.enter="updateSearchQuery"
            />
            <b-input-group-append>
              <b-button
                variant="primary"
                @click="updateSearchQuery"
              >
                <feather-icon icon="SearchIcon" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col
          v-if="showRoleFilter"
          cols="12"
          md="3"
          sm="6"
          class="mb-md-0 mb-2"
        >
          <label>{{ $t('Role') }}</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="roleOptions"
            :value="roleFilter"
            :reduce="(val) => val.id"
            label="display_name"
            class="w-100"
            @input="(val) => $emit('update:roleFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          sm="6"
          class="mb-md-0 mb-2"
        >
          <label>{{ $t('Department') }}</label>
          <treeselect
            :multiple="false"
            :options="departmentOptions"
            :disable-branch-nodes="false"
            :default-expand-level="5"
            search-nested
            :clearable="true"
            no-results-text="Không tìm thấy kết quả"
            no-options-text="Không có lựa chọn nào"
            placeholder="Chọn phòng"
            loading-text="Đang tải"
            search-prompt-text="Nhập tên"
            :normalizer="normalizerTreeList"
            :always-open="false"
            @input="(val) => $emit('update:departmentFilter', val)"
          />
        </b-col>

        <b-col
          v-if="showPositionFilter"
          cols="12"
          md="3"
          sm="6"
          class="mb-md-0 mb-2"
        >
          <label>Chức vụ</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="positionFilter"
            :options="positionOptions"
            class="w-100"
            :reduce="(val) => val.id"
            label="name"
            @input="(val) => $emit('update:positionFilter', val)"
          />
        </b-col>

        <b-col
          v-if="showStatusFilter"
          cols="12"
          md="3"
          sm="6"
          class="mb-md-0 mb-2"
        >
          <label>Trạng thái</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="statusFilter"
            :options="statusOptions"
            class="w-100"
            :reduce="(val) => val.id"
            @input="(val) => $emit('update:statusFilter', val)"
          />
        </b-col>
        <!-- <b-col
          v-if="showOnlineFilter"
          cols="12"
          md="3"
          sm="6"
          class="mb-md-0 mb-2"
        >
          <label>Trực tuyến</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="onlineFilter"
            :options="onlineOptions"
            class="w-100"
            :reduce="(val) => val.id"
            @input="(val) => $emit('update:onlineFilter', val)"
          />
        </b-col> -->
        <!-- <b-col
          v-if="showBanFilter"
          cols="12"
          md="3"
          sm="6"
          class="mb-md-0 mb-2"
        >
          <label>Khóa</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="banFilter"
            :options="banOptions"
            class="w-100"
            :reduce="(val) => val.id"
            @input="(val) => $emit('update:banFilter', val)"
          />
        </b-col> -->

      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput, BInputGroup, BInputGroupAppend, BButton,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import Treeselect from '@riophae/vue-treeselect'
import useUsers from './useUsers';
import useDepartments from '../department/useDepartments'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    vSelect,
    Treeselect,
  },
  props: {
    roleFilter: {
      type: [Number, null],
      default: null,
    },
    departmentFilter: {
      type: [Number, null],
      default: null,
    },
    statusFilter: {
      type: [Number, null],
      default: null,
    },
    onlineFilter: {
      type: [Number, null],
      default: null,
    },
    banFilter: {
      type: [Number, null],
      default: null,
    },
    positionFilter: {
      type: [Number, null],
      default: null,
    },
    searchQuery: {
      type: [String, null],
      default: null,
    },
    departmentOptions: {
      type: Array,
      required: true,
    },
    positionOptions: {
      type: Array,
      default: () => [],
      required: false,
    },
    roleOptions: {
      type: Array,
      required: true,
    },
    banOptions: {
      type: Array,
      required: true,
    },
    showOnlineFilter: {
      type: Boolean,
      default: true,
    },
    showRoleFilter: {
      type: Boolean,
      default: true,
    },
    showStatusFilter: {
      type: Boolean,
      default: true,
    },
    showBanFilter: {
      type: Boolean,
      default: true,
    },
    showPositionFilter: {
      type: Boolean,
      default: true,
    },
  },

  setup(props, { emit }) {
    const localSearchQuery = ref('')
    const { statusOptions, genderOptions, onlineOptions } = useUsers();
    const updateSearchQuery = () => {
      emit('update:searchQuery', localSearchQuery.value)
    }

    const {
      normalizerTreeList,
    } = useDepartments();

    return {
      localSearchQuery,
      statusOptions,
      onlineOptions,
      genderOptions,
      updateSearchQuery,
      normalizerTreeList,
    };
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
